import React, { ComponentPropsWithoutRef, FC } from "react";
import cn from "classnames";
import { STAT_ITEMS } from "./constanst";
import { SafeHTML } from "src/components/SafeHTML";

interface Props extends ComponentPropsWithoutRef<"div"> {}

export const StatsCard: FC<Props> = ({ className, ...props }) => (
  <div
    {...props}
    className={cn(
      "flex items-center justify-center bg-white-base rounded-2xl text-black-base px-4 py-5 xl:p-10 4xl:py-12.5 4xl:pt-9.5",
      className
    )}
  >
    <div className="flex justify-center items-baseline gap-3 text-center xl:gap-8 4xl:gap-11">
      {STAT_ITEMS.map(({ value, label }) => (
        <div
          key={value}
          className="flex flex-col items-center justify-center gap-1 xl:gap-0 flex-1"
        >
          <h2 className="bg-gradient-to-l from-teal-base via-green-base to-green-base text-transparent bg-clip-text font-spaceland leading-none text-48 md:text-9xl 4xl:text-150">
            {value}
          </h2>
          <SafeHTML
            html={label}
            tag="p"
            className="text-10 leading-tight text-green-base font-black xl:text-sm 4xl:text-base"
          />
        </div>
      ))}
    </div>
  </div>
);
